var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService } from '@base/api/api.gateway';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HelpersService, HeaderService, NavigationService } from '@base/shared/services';
import { ProjectsService } from '@eyrus/shared/services';
import { TranslateService } from '@ngx-translate/core';
import { get, omit } from 'lodash';
import { DailyLogsService } from '@eyrus/modules/daily-logs/daily-logs.service';
var NewNoteModalContent = /** @class */ (function () {
    function NewNoteModalContent(activeModal, router, navigator, activeRoute, formBuilder, api, helpers, projectService, translate, header, navigation, dailyLogService
    //
    ) {
        this.activeModal = activeModal;
        this.router = router;
        this.navigator = navigator;
        this.activeRoute = activeRoute;
        this.formBuilder = formBuilder;
        this.api = api;
        this.helpers = helpers;
        this.projectService = projectService;
        this.translate = translate;
        this.header = header;
        this.navigation = navigation;
        this.dailyLogService = dailyLogService;
        this.loading = true;
        this.readOnly = false;
        this.subscriptions = {};
        this.isQuick = false;
        this.isMobile = false;
    }
    /** TODO: use note.component */
    NewNoteModalContent.prototype.ngOnInit = function () {
        var _this = this;
        this.bootstrapForm({});
        this.currentNote = this.activeRoute.snapshot.paramMap.get('id') || this.currentNoteId;
        if (this.currentNote)
            this.getCurrentNote();
        this.subscriptions.queryParams = this.activeRoute.queryParams
            .subscribe(function (params) {
            _this.readOnly = params.statusTypeName ? params.statusTypeName === 'submitted' : false;
        });
        this.loading = false;
        this.initializeQueryParams();
    };
    NewNoteModalContent.prototype.ngOnDestroy = function () {
        var _this = this;
        this.header.quickBack.next(null);
        var keys = Object.keys(this.subscriptions);
        keys.forEach(function (key) { return _this.subscriptions[key].unsubscribe(); });
    };
    /**
     * Cancel note creation / edition
     */
    NewNoteModalContent.prototype.cancel = function () {
        if (this.isMobile) {
            if (this.isQuick)
                return this.goBack();
            this.navigator.back();
        }
        else {
            this.closeModal({ saved: true });
            if (this.isQuick) {
                var params = omit(this.activeRoute.snapshot.queryParams, 'type');
                this.router.navigate([], {
                    queryParams: params,
                });
            }
        }
    };
    /**
     * Close current Modal
     * @param {[type]} result [description]
     */
    NewNoteModalContent.prototype.closeModal = function (result) {
        this.activeModal.close(result);
    };
    /**
     * create / edit current note
     */
    NewNoteModalContent.prototype.save = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        if (!valid) {
            this.helpers.displayFormErrors(this.noteForm);
            return;
        }
        this.loading = true;
        this.helpers.setformAsValid(this.noteForm);
        this.projectService.createDailyLog()
            .then(function (res) {
            var dailyLogId = _this.projectService.dailyLog;
            var payload = __assign({}, value, { dailyLogId: dailyLogId });
            if (_this.currentNote)
                payload = _this.generatePatchOp(value);
            var action = _this.currentNote ? _this.api.dailyLogs.updateubmitterNotes(dailyLogId, _this.currentNote, payload) :
                _this.api.dailyLogs.storeSubmitterNotes(dailyLogId, payload);
            return action.toPromise();
        })
            .then(function (res) {
            var _label = _this.currentNote ? 'common.successfullyUpdated' : 'common.successfullyCreated';
            var _title = _this.translate.instant('notes.note');
            var _msg = _this.translate.instant(_label, { section: _title });
            _this.helpers.successMessage('', _msg);
            _this.cancel();
        })
            .catch(function (error) {
            _this.loading = false;
            var errors = get(error, 'error.errors') || [];
            _this.helpers.setFormError(_this.noteForm, false);
            errors.forEach(function (err) {
                var input = _this.noteForm.get(err.fieldName);
                if (!input)
                    return;
                input.setErrors({
                    submitted: true,
                    message: err.errorMessage
                });
            });
        });
    };
    /**
     * Get current note
     */
    NewNoteModalContent.prototype.getCurrentNote = function () {
        // const note = this.projectService.currentNote || {};
        // const keys = Object.keys(note);
        // if (!keys.length)
        //   return;
        var _this = this;
        // this.bootstrapForm(note);
        var dailyLogId = this.projectService.dailyLog;
        this.api.dailyLogs.getSubmitterNote(dailyLogId, this.currentNote).toPromise()
            .then(function (result) {
            var note = result.dailyNoteListItem;
            _this.bootstrapForm(note);
        }).catch(function (err) {
            _this.helpers.errorMessage(err);
        });
    };
    /**
     * Initialize note form
     */
    NewNoteModalContent.prototype.bootstrapForm = function (data) {
        this.noteForm = this.formBuilder.group({
            note: [data.note || '', [Validators.required]],
        });
    };
    // Generate patch value
    NewNoteModalContent.prototype.generatePatchOp = function (data) {
        return [
            {
                op: 'replace',
                path: '/note',
                value: data.note
            }
        ];
    };
    /**
     * List router params
     */
    NewNoteModalContent.prototype.initializeQueryParams = function () {
        var _this = this;
        this.subscriptions.queryParams = this.activeRoute
            .queryParams
            .subscribe(function (params) {
            if (params.type && params.type === 'quick') {
                _this.isQuick = true;
                _this.header.quickBack.next({
                    action: function () { return _this.goBack(); }
                });
            }
        });
    };
    /**
     * Quick access go back
     */
    NewNoteModalContent.prototype.goBack = function () {
        return this.navigation.navigate({
            type: 'basic',
            stepsBack: 2
        });
    };
    return NewNoteModalContent;
}());
export { NewNoteModalContent };
